// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__Khg0q","title":"ClientReferral_title__13UpV","itemText":"ClientReferral_itemText__8QHhH"};